import React, { useState } from "react";
import "./Vessel.css";

// ✅ Replace with your local ship image:
// import shipBg from "./assets/ship.jpg";
const shipBg = "https://images.unsplash.com/photo-1605745341112-85968b19335b?w=1600&q=80";

export default function VesselDashboard() {
  const [activeTab, setActiveTab] = useState("Map");
  const [open, setOpen] = useState({
    operational: true,
    performance: true,
    service: true,
    fault: true,
  });
  const toggle = (k) => setOpen((p) => ({ ...p, [k]: !p[k] }));

  return (
        <React.Fragment>
          <div className="page-content">
    <div className="">

      {/* ── NAV ── */}
      <header className="vd__nav">
        <div className="vd__nav-tabs">
          <button className="vd__vessel-pill">
            🚢 MV Atlas Prime <span style={{ fontSize: 10 }}>▾</span>
          </button>

          {["Map", "Crew", "Reports"].map((t) => (
            <button
              key={t}
              onClick={() => setActiveTab(t)}
              className={`vd__tab${activeTab === t ? " vd__tab--active" : ""}`}
            >
              {t === "Map" && "🗺 "}
              {t === "Crew" && "👥 "}
              {t === "Reports" && "📋 "}
              {t}
            </button>
          ))}

          <button
            onClick={() => setActiveTab("Alerts")}
            className={`vd__tab${activeTab === "Alerts" ? " vd__tab--active" : ""}`}
            style={{ position: "relative" }}
          >
            🔔 Alerts
            <span className="vd__badge">3</span>
          </button>
        </div>

        <div className="vd__nav-right">
          <div className="vd__nav-stat">
            <span className="vd__nav-stat-label">UPTIME</span>
            <span className="vd__nav-stat-value">25/06/2024 03:27:35</span>
          </div>
          <div className="vd__nav-stat">
            <span className="vd__nav-stat-label">SYSTEM STATUS</span>
            <span className="vd__nav-stat-value" style={{ color: "#16a34a", display: "flex", alignItems: "center", gap: 4 }}>
              <span className="vd__online-dot" /> Online
            </span>
          </div>
          <div className="vd__nav-stat">
            <span className="vd__nav-stat-label">TIME UTC</span>
            <span className="vd__nav-stat-value">14:27:35</span>
          </div>
        </div>
      </header>

      {/* ── BODY ── */}
      <div className="vd__body">

        {/* LEFT — ship */}
        <div
          className="vd__ship-pane"
          style={{ backgroundImage: `url(${shipBg})` }}
        >
          {/* stat chips */}
          <div className="vd__chips-row">
            <div className="vd__chip">
              <div className="vd__chip-label">SOG</div>
              <div className="vd__chip-big">12<span className="vd__chip-unit">Kn</span></div>
            </div>
            <div className="vd__chip">
              <div className="vd__chip-label">STW</div>
              <div className="vd__chip-big">12.5<span className="vd__chip-unit">Kn</span></div>
            </div>
            <div className="vd__chip">
              <div className="vd__chip-label">CONDITION</div>
              <div className="vd__chip-green">Sailing</div>
            </div>
            <div className="vd__chip">
              <div className="vd__chip-label">DRAFT</div>
              <div style={{ fontSize: 12, color: "#1e293b", lineHeight: 1.7 }}>
                <b>Fwd</b> <span className="vd__chip-blue">5.6 m</span><br />
                <b>Aft</b> <span className="vd__chip-blue">5.4 m</span>
              </div>
            </div>
            <div className="vd__chip">
              <div className="vd__chip-label">CONDITION</div>
              <div className="vd__chip-green">Sailing</div>
            </div>
          </div>

          {/* weather chips */}
          <div className="vd__weather-row">
            <div className="vd__chip--row">
              <span style={{ fontSize: 20 }}>🌊</span>
              <div>
                <div className="vd__chip-sub">Weather Conditions</div>
                <div className="vd__chip-text">6 kts NE — Stable Seas</div>
              </div>
            </div>
            <div className="vd__chip--row">
              <span style={{ fontSize: 20 }}>📍</span>
              <div>
                <div className="vd__chip-sub">Latitude: 35.518</div>
                <div className="vd__chip-text">Longitude: -63.387</div>
              </div>
            </div>
          </div>

          {/* crew bar */}
          <div className="vd__crew-bar">
            <div className="vd__crew-left">
              <div className="vd__crew-avatar">👤</div>
              <div>
                <div className="vd__crew-count">Assigned Crews : 3</div>
                <div className="vd__crew-names">Alice Chen , Bob Martin , Stefen</div>
              </div>
            </div>
            <button className="vd__add-btn">＋</button>
          </div>
        </div>

        {/* ── RIGHT PANEL ── */}
        <aside className="vd__panel">

          {/* OPERATIONAL STATUS */}
          <div className="vd__section">
            <div className="vd__section-header" onClick={() => toggle("operational")}>
              <div className="vd__section-title"><span>⚙</span> OPERATIONAL STATUS</div>
              <span className="vd__section-chevron" style={{ transform: open.operational ? "rotate(0deg)" : "rotate(180deg)" }}>▲</span>
            </div>
            {open.operational && (
              <div style={{ marginTop: 8 }}>
                <div className="vd__op-grid">
                  {[["SOG","12 Kn"],["STW","12.5 Kn"],["DRAFT FWD","5.6 m"],["DRAFT AFT","5.4 m"]].map(([l,v]) => (
                    <div key={l} className="vd__card">
                      <span className="vd__card-label">{l}</span>
                      <span className="vd__card-value">{v}</span>
                    </div>
                  ))}
                </div>
                <div className="vd__cond-row">
                  <span className="vd__card-label">CONDITION</span>
                  <span className="vd__card-value vd__card-value--green">Sailing</span>
                </div>
              </div>
            )}
          </div>

          {/* LIVE PERFORMANCE */}
          <div className="vd__section">
            <div className="vd__section-header" onClick={() => toggle("performance")}>
              <div className="vd__section-title"><span>⚡</span> LIVE PERFORMANCE</div>
              <span className="vd__section-chevron" style={{ transform: open.performance ? "rotate(0deg)" : "rotate(180deg)" }}>▲</span>
            </div>
            {open.performance && (
              <div style={{ marginTop: 8 }}>
                <div className="vd__eng-title">MAIN ENGINE</div>
                <div className="vd__perf-grid">
                  {[["Power","11500 KW"],["RPM","57 rev/min"],["Load","48.52"]].map(([l,v]) => (
                    <div key={l} className="vd__card">
                      <span className="vd__card-label">{l}</span>
                      <span className="vd__card-value vd__card-value--blue">{v}</span>
                    </div>
                  ))}
                </div>
                <div className="vd__eng-title" style={{ marginTop: 10 }}>AUXILIARY ENGINE</div>
                <div className="vd__aux-grid">
                  {[["AE 1","640 KW",true],["AE 2","0 KW",false],["AE 3","515 KW",true],["AE4","0 KW",false]].map(([l,v,on]) => (
                    <div key={l} className="vd__aux-card">
                      <span className="vd__aux-label">{l}</span>
                      <span className={`vd__aux-value ${on ? "vd__card-value--green" : "vd__card-value--muted"}`}>{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* SERVICE HISTORY */}
          <div className="vd__section">
            <div className="vd__section-header" onClick={() => toggle("service")}>
              <div className="vd__section-title"><span>🔧</span> SERVICE HISTORY</div>
              <span className="vd__section-chevron" style={{ transform: open.service ? "rotate(0deg)" : "rotate(180deg)" }}>▲</span>
            </div>
            {open.service && (
              <div style={{ marginTop: 8 }}>
                {[
                  ["Minor blade repair","20/12/2023"],
                  ["Routine inspection","24/11/2023"],
                  ["Sensor recalibration","20/12/2023"],
                ].map(([name, date]) => (
                  <div key={name} className="vd__svc-row">
                    <div>
                      <span className="vd__svc-name">{name}</span>
                      <span className="vd__svc-date"> – {date}</span>
                    </div>
                    <button className="vd__rpt-btn">≡ Report</button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* FAULT SUMMARY */}
          <div className="vd__section">
            <div className="vd__section-header" onClick={() => toggle("fault")}>
              <div className="vd__section-title"><span>⚠</span> FAULT SUMMARY</div>
              <span className="vd__section-chevron" style={{ transform: open.fault ? "rotate(0deg)" : "rotate(180deg)" }}>▲</span>
            </div>
            {open.fault && (
              <div className="vd__fault-grid" style={{ marginTop: 8 }}>
                <div className="vd__card">
                  <span className="vd__card-label">MTTR (AVG)</span>
                  <span className="vd__card-value vd__card-value--amber">2.1 h</span>
                </div>
                <div className="vd__card">
                  <span className="vd__card-label">TYPE</span>
                  <span className="vd__card-value vd__card-value--amber" style={{ fontSize: 12 }}>
                    Temperature – Nacelle
                  </span>
                </div>
              </div>
            )}
          </div>

        </aside>
      </div>
    </div>
    </div>
    </React.Fragment>
  );
}
